<script lang="ts">
import { reactive, defineComponent } from '@vue/composition-api';
// @ts-ignore
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';

import NotificationListItem from './NotificationListItem.vue';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

interface IProps {
    items: [];
}

const NotificationsList = defineComponent({
    name: 'NotificationsList',
    components: {
        NotificationListItem,
        DynamicScroller,
        DynamicScrollerItem,
    },
    props: { items: Array },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        const height = document.getElementById('notifications-panel').offsetHeight - 100;

        return {
            state,
            height,
        };
    },
});

export default NotificationsList;
</script>
 
<template>
  <DynamicScroller
    :items="items"
    :min-item-size="54"
    :buffer="20"
    page-mode
  >
    <template #default="{ item, index, active }">
      <DynamicScrollerItem
        :item="item"
        :active="active"
        :data-index="index"
      >
        <NotificationListItem
          :key="item.id"
          :item="item"
          :index="index"
          :lastVisible="lastVisible"
          @updateLastVisible="onUpdateLastVisible"
          @onDismissNotification="$listeners.onDismissNotification"
          @onOpenStoryMap="$listeners.onOpenStoryMap"
          @onOpenCard="$listeners.onOpenCard"
          @onOpenIdea="$listeners.onOpenIdea"
          @onOpenFeedback="$listeners.onOpenFeedback"
          @onOpenRoadmapCard="$listeners.onOpenRoadmapCard"
          @onAcceptInvitation="$listeners.onAcceptInvitation"
        />
        <v-divider v-if="index + 1 < items.length" :key="index" />
      </DynamicScrollerItem>
    </template>
  </DynamicScroller>
</template>

<style lang="scss" scoped>
</style>
